import { render } from "./AppPackagingPrint.vue?vue&type=template&id=57194f50"
import script from "./AppPackagingPrint.vue?vue&type=script&lang=js"
export * from "./AppPackagingPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__